import { CardType, StateInfo, StatusType } from 'types';

export const removeSpaces = (str: string) => str.replace(/\s/g, '');

export const extractNumbers = (inputString: string): string =>
  inputString.replace(/\D/g, '');

export const getCardType = (number: string) => {
  const cardsRegExp: { [key in CardType]: RegExp } = {
    electron: /^(4026|417500|4508|4844|491([37]))/,
    visa: /^4[0-9]{3}/,
    mastercard:
      /^(5[1-5][0-9]{2}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))/,
    amex: /^3[47]/,
    discover:
      /^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)/,
    diners: /^36'/,
    dinersBlanche: /^30[0-5]/,
    jcb: /^35(2[89]|[3-8][0-9])/
  };

  if (removeSpaces(number).match(cardsRegExp.electron) != null)
    return 'electron';

  if (removeSpaces(number).match(cardsRegExp.visa) != null) return 'visa';

  if (removeSpaces(number).match(cardsRegExp.mastercard) != null)
    return 'mastercard';

  if (removeSpaces(number).match(cardsRegExp.amex) != null) return 'amex';

  if (removeSpaces(number).match(cardsRegExp.discover) != null)
    return 'discover';

  if (removeSpaces(number).match(cardsRegExp.diners) != null) return 'diners';

  if (removeSpaces(number).match(cardsRegExp.dinersBlanche) != null)
    return 'diners';

  if (removeSpaces(number).match(cardsRegExp.jcb) != null) return 'jcb';

  return '';
};

export const getYearOptions = () => {
  const currentYear = new Date().getFullYear();
  const years = [];

  for (let i = 0; i <= 10; i += 1) {
    const year = currentYear + i;
    years.push({ value: year.toString(), label: year.toString() });
  }

  return years;
};

export const transformToReactSelectOptions = (
  stateInfoArray: StateInfo[] | null
) => {
  if (!stateInfoArray?.length || !Array.isArray(stateInfoArray)) {
    return [];
  }

  return stateInfoArray.map((stateInfo) => ({
    label: stateInfo?.state ?? '',
    value: stateInfo?.abbr ?? ''
  }));
};

export const getStatusIcon = (status: number): StatusType => {
  switch (status) {
    case 0:
      return 'forbid';
    case 1:
      return 'premium';
    default:
      return 'allow';
  }
};

export const getAbbrState = (states: StateInfo[]) => {
  const stateAbbreviationMap: { [abbr: string]: string } = {};
  states.forEach((state) => {
    stateAbbreviationMap[state.abbr] = state.state;
  });
  return stateAbbreviationMap;
};
